import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}
    async canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):  Promise<boolean | UrlTree> {
        const isAuth = await this.authService.getIsAuth();
        if (!isAuth) {
            this.router.navigate(['/']);
            return false;
        } else {
            return true;
        }
    }
}
